import React, { useState } from 'react';
import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const getLogin = async (param) => {

    try {
        const response = await CALL_API.post('Login', param);

        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const GetProfile = async (param) => {

    var tokend = "Bearer " + param.replace("Bearer ", "");
    try {
        const response = await CALL_API.get('Login/GetProfile', {
            headers: {
                'Authorization': `${tokend}`
            }
        });
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const SetResetPassword = async (param) => {

    try {
        const response = await CALL_API.post('user/ResetPassword', param);

        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const SetChangePassword = async (param) => {

    try {
        const response = await CALL_API.post('user/ChangePassword', param);

        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const SetPassword = async (param) => {

    try {
        const response = await CALL_API.post('user/SetPassword', param);

        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setLogout = async (param) => {

    try {
        const response = await CALL_API.post('account/logout', param);

        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
